export default __webpack_public_path__ + "static/media/op-ku-picturemark-d.c9985a27.svg";